import React, { Component } from "react";
import deleteicon from "../../assets/images/delete-gray.svg";
import pluswIcon from "./../../assets/images/plus.svg";

class RiskLevelConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: props.riskConfigData?.length > 0
        ? props.riskConfigData
        : [
            {
              riskLevel: "Low Risk",
              level: "100-90%",
              followUp: "240 Days",
              color: "#00FF00",
            },
            {
              riskLevel: "Moderate Risk",
              level: "89-80%",
              followUp: "180 Days",
              color: "#FFFFFF",
            },
            {
              riskLevel: "Moderate to High Risk",
              level: "79-70%",
              followUp: "120 Days",
              color: "#FFFF00",
            },
            {
              riskLevel: "High Risk",
              level: "69-0%",
              followUp: "60 Days",
              color: "#FF0000",
            },
          ],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.rows !== this.state.rows &&
      typeof this.props.onChange === "function"
    ) {
      this.props.onChange(this.state.rows);
    }
  }

  componentDidMount() {
    this.props.rowData(this.state.rows);
    // console.log( "config data ", this.props.riskConfigData);
    // console.log( "config rows ", this.state.rows);
  }

  handleAddRow = () => {
    this.setState((prevState) => ({
      rows: [
        ...prevState.rows,
        { riskLevel: "", level: "", followUp: "", color: "#FFFFFF" },
      ],
    }));
  };

  handleRemoveRow = (index) => {
    this.setState((prevState) => {
      const rows = [...prevState.rows];
      rows.splice(index, 1);
      return { rows };
    });
  };

  handleChange = (index, field, value) => {
    this.setState((prevState) => {
      const rows = [...prevState.rows];
      rows[index][field] = value;
      return { rows };
    });
  };

  render() {
    const { rows } = this.state;

    return (
      <>
        <div className="risk-level-container text-center">
          <div className="risk-level-grid">
            {/* Header Row */}
            <div className="risk-level-header">
              <div className="risk-col">Risk Level</div>
              <div className="risk-col">Level</div>
              <div className="risk-col">Follow up Site Visit</div>
              <div className="risk-col">Color</div>
              <div className="risk-col">Actions</div>
            </div>

            {rows.length > 0 ? (
              rows.map((row, index) => (
                <div className="risk-level-row" key={index}>
                  <div className="risk-col">
                    <input
                      type="text"
                      className="form-control max_width_100"
                      value={row.riskLevel}
                      onChange={(e) =>
                        this.handleChange(index, "riskLevel", e.target.value)
                      }
                    />
                  </div>
                  <div
                    className="risk-col"
                    // style={{ backgroundColor: row.color }}
                  >
                    <input
                      type="text"
                      className="form-control max_width_100"
                      ref={(el) => {
                        if (el)
                          el.style.setProperty(
                            "background-color",
                            row.color,
                            "important"
                          );
                      }}
                      value={row.level}
                      onChange={(e) =>
                        this.handleChange(index, "level", e.target.value)
                      }
                    />
                  </div>
                  <div className="risk-col">
                    <input
                      type="text"
                      className="form-control max_width_100"
                      value={row.followUp}
                      onChange={(e) =>
                        this.handleChange(index, "followUp", e.target.value)
                      }
                    />
                  </div>
                  <div className="risk-col">
                    <input
                      type="color"
                      value={row.color}
                      className="form-control max_width_100"
                      onChange={(e) =>
                        this.handleChange(index, "color", e.target.value)
                      }
                    />
                  </div>
                  <div className="risk-col">
                    <div className="action-btm-border">
                      <button
                        onClick={() => this.handleRemoveRow(index)}
                        className="deleteCat position-static"
                      >
                        <img src={deleteicon} alt="Delete" />
                      </button>

                      {/* Add Button - show only on last row */}
                      {index === rows.length - 1 && (
                        <button
                          onClick={this.handleAddRow}
                          className="addCat new_btn_add position-static"
                        >
                          <img src={pluswIcon} alt="Add" />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              // If no rows, show add button
              <div className="risk-level-row blank-btn-row">
                <div className="risk-col">
                  <div className="">
                    <div className="text-right py-1 px-3">
                      <button
                        onClick={this.handleAddRow}
                        className="button addCat new_btn_add position-static"
                      >
                        <img src={pluswIcon} alt="Add" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default RiskLevelConfig;
